import { IAppointment, IAppointmentActivity, IIconOption } from '../../types'

export const appointmentIconCheck = (
  appointment: IAppointment,
  activity: IAppointmentActivity,
): IIconOption => {
  const icons: IIconOption = {
    left: [],
    right: [],
  }

  if (appointment.isOnlineBooked) {
    icons.right.push('earth-europe')
  }
  if (appointment.appointmentNotes) {
    icons.right.push('circle-info')
  }
  if (appointment.reminderStatus) {
    if (appointment.reminderStatus === 'pending') {
      icons.left.push('check')
    } else if (appointment.reminderStatus === 'delivered') {
      icons.left.push('check-double')
    } else {
      icons.left.push('xmark')
    }
  }
  if (activity.isLocked) {
    icons.left.push('lock-keyhole')
  }
  if (appointment.isBirthDay) {
    icons.left.push('cake-candles')
  }
  return icons
}
